import { Link } from "gatsby"
import * as React from "react"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock"
import Hamburger from "hamburger-react"
import Logo from "./Logo"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons"
import { Theme } from "../common/Theme"

const Nav = ({ isDesktop, subitems, onClickItem }: any) => {
  const navbar = isDesktop ? "navbar-end has-text-centered" : "p-6"
  const item1 = isDesktop ? "navbar-item has-dropdown is-hoverable " : ""
  const item1NoDropdown = isDesktop ? "navbar-item" : ""
  const item1Link = isDesktop ? "navbar-link" : "is-size-3 item-header"
  const item1Href = isDesktop ? "" : "is-size-3 item-header"
  const item2 = isDesktop ? "navbar-dropdown" : ""
  const item2Item = isDesktop ? "navbar-item" : "item-link is-block"

  const whySpringClass = !isDesktop && !subitems[0] ? "subitems-hide" : ""
  const learnClass = !isDesktop && !subitems[1] ? "subitems-hide" : ""
  const projectsClass = !isDesktop && !subitems[2] ? "subitems-hide" : ""
  const academyClass = !isDesktop && !subitems[3] ? "subitems-hide" : ""
  const communityClass = !isDesktop && !subitems[4] ? "subitems-hide" : ""

  const [expanded, setExpanded] = React.useState(false)

  const onClickHandler = (index: number) => {
    if (isDesktop) {
      setExpanded(!expanded)
    }
    if (!isDesktop && onClickItem) {
      onClickItem(index)
    }
  }

  return (
    <div aria-label="navigation" className={`${navbar}`}>
      <div className={`${item1} ${whySpringClass} navbar-group-item`}>
        <span
          role="button"
          aria-expanded={expanded}
          tabIndex={0}
          className={`${item1Link}`}
          onClick={() => {
            onClickHandler(0)
          }}
        >
          Why Spring
        </span>
        <ul className={`${item2} is-boxed`}>
          <li>
            <Link className={`${item2Item}`} to="/why-spring">
              Overview
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/ai">
              Generative AI
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/microservices">
              Microservices
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/reactive">
              Reactive
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/event-driven">
              Event Driven
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/cloud">
              Cloud
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/web-applications">
              Web Applications
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/serverless">
              Serverless
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/batch">
              Batch
            </Link>
          </li>
        </ul>
      </div>

      <div className={`${item1} ${learnClass} navbar-group-item`}>
        <span
          role="button"
          tabIndex={0}
          aria-expanded={expanded}
          className={`${item1Link}`}
          onClick={() => {
            onClickHandler(1)
          }}
        >
          Learn
        </span>
        <ul className={`${item2} is-boxed navbar-group-item`}>
          <li>
            <Link className={`${item2Item}`} to="/learn">
              Overview
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/quickstart">
              Quickstart
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/guides">
              Guides
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/blog">
              Blog
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/security">
              Security Advisories
            </Link>
          </li>
        </ul>
      </div>

      <div className={`${item1} ${projectsClass} navbar-group-item`}>
        <span
          role="button"
          tabIndex={0}
          aria-expanded={expanded}
          className={`${item1Link}`}
          onClick={() => {
            onClickHandler(2)
          }}
        >
          Projects
        </span>
        <ul className={`${item2} is-boxed navbar-group-item`}>
          <li>
            <Link className={`${item2Item}`} to="/projects">
              Overview
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/projects/spring-boot">
              Spring Boot
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/projects/spring-framework">
              Spring Framework
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/projects/spring-cloud">
              Spring Cloud
            </Link>
          </li>
          <li>
            <Link
              className={`${item2Item}`}
              to="/projects/spring-cloud-dataflow"
            >
              Spring Cloud Data Flow
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/projects/spring-data">
              Spring Data
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/projects/spring-integration">
              Spring Integration
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/projects/spring-batch">
              Spring Batch
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/projects/spring-security">
              Spring Security
            </Link>
          </li>
          <li>
            <Link className={`${item2Item} mb-5`} to="/projects/spring-ai">
              Spring AI
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/projects#release-calendar">
              Release Calendar
            </Link>
          </li>
          <li>
            <Link className={`${item2Item} mb-5`} to="/security">
              Security advisories
            </Link>
          </li>
          <li>
            <div className={`${item2Item}`}>DEVELOPMENT TOOLS</div>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/tools">
              Spring Tools
            </Link>
          </li>
          <li>
            <a
              aria-label="Spring Initializr, Open in a new tab"
              href="https://start.spring.io/"
              className={`${item2Item}`}
            >
              Spring Initializr
              <FontAwesomeIcon
                className="navbar-icon ml-2"
                icon={faArrowUpRightFromSquare}
              />
            </a>
          </li>
        </ul>
      </div>

      <div className={`${item1} ${academyClass} navbar-group-item`}>
        <span
          role="button"
          tabIndex={0}
          aria-expanded={expanded}
          className={`${item1Link}`}
          onClick={() => {
            onClickHandler(3)
          }}
        >
          Academy
        </span>
        <ul className={`${item2} is-boxed`}>
          <li>
            <Link
              className={`${item2Item}`}
              to="https://spring.academy/courses"
            >
              Courses
            </Link>
          </li>
          <li>
            <Link
              className={`${item2Item}`}
              to="https://spring.academy/learning-path"
            >
              Get Certified
            </Link>
          </li>
        </ul>
      </div>

      <div className={`${item1} ${communityClass} navbar-group-item`}>
        <span
          role="button"
          tabIndex={0}
          aria-expanded={expanded}
          className={`${item1Link}`}
          onClick={() => {
            onClickHandler(4)
          }}
        >
          Community
        </span>
        <ul className={`${item2} is-boxed`}>
          <li>
            <Link className={`${item2Item}`} to="/community">
              Overview
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/events">
              Events
            </Link>
          </li>
          <li>
            <Link className={`${item2Item}`} to="/authors">
              Authors
            </Link>
          </li>
        </ul>
      </div>
      <div className={`${item1NoDropdown}`}>
        <a className={`${item1Href}`} href="https://enterprise.spring.io">Tanzu Spring</a>
      </div>
    </div>
  )
}

const Navbar = () => {
  const navItemsCount = 6
  const [stateSubItems, setStateSubItems] = React.useState(
    [].fill(false, 0, navItemsCount)
  )

  const wrapper = React.useRef(null)
  const [isOpen, setIsOpen] = React.useState(false)

  React.useEffect(() => {
    if (wrapper?.current && isOpen) {
      disableBodyScroll(wrapper?.current)
    }
    return () => {
      clearAllBodyScrollLocks()
    }
  }, [wrapper, isOpen])

  const toggleHamburger = () => {
    setStateSubItems([].fill(false, 0, navItemsCount))
    setIsOpen(!isOpen)
    // setNavbarActive(!navbarActive)
  }

  const onEnter = () => {
    setTimeout(() => {
      setIsOpen(true)
    }, 350)
  }
  const onEntered = () => {}

  const onEnded = () => {
    setIsOpen(false)
  }
  const onExited = () => {}

  return (
    <nav
      id="header"
      className={`navbar is-transparent ${isOpen ? "is-open" : ""}`}
    >
      <div className="container is-hidden-mobile is-hidden-tablet-only">
        <div className="navbar-brand">
          <Link to="/" className="navbar-item" title="Home">
            <Logo />
          </Link>
        </div>
        <div className={`navbar-menu`}>
          <Nav isDesktop={true} />
          <Theme />
        </div>
      </div>

      <div className="container navbar-mobile is-hidden-desktop">
        <div className="navbar-brand">
          <Link to="/" className="navbar-item" title="Logo">
            <Logo />
          </Link>
          {/* Hamburger menu */}
          <div
            className={`navbar-burger`}
            data-target="navMenu"
            role="menuitem"
            tabIndex={0}
            onKeyPress={() => toggleHamburger()}
            onClick={() => toggleHamburger()}
          >
            <Hamburger size={24} />
          </div>
        </div>
        <div id="navMenu" className={`has-background-dark has-text-white`}>
          <TransitionGroup component={null}>
            {isOpen && (
              <CSSTransition
                onEnter={onEnter}
                onEntered={onEntered}
                onExit={onEnded}
                onExited={onExited}
                classNames="wrapper"
                timeout={500}
              >
                <div className="wrapper" ref={wrapper}>
                  <Nav
                    onClickItem={(index: number) => {
                      const newVal = !stateSubItems[index]
                      const newState = [].fill(false, 0, navItemsCount)
                      newState[index] = newVal
                      setStateSubItems(newState)
                    }}
                    subitems={stateSubItems}
                    isDesktop={false}
                  />
                </div>
              </CSSTransition>
            )}
          </TransitionGroup>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
